import { composeIO } from 'react-compose-io'
import { moedaColoridaIO } from './MoedaColorida.IO'
import { MoedaColoridaView } from './MoedaColorida.View'

export const MoedaColorida = composeIO(MoedaColoridaView, moedaColoridaIO)
